import * as React from 'react'
import { connect } from 'react-redux'
import {Card, CardBody, CardImg, Col, Row} from "reactstrap";
import {
    ConfiguratorProduct,
    ConfiguratorProductBuckets,
    ConfiguratorProductCategories,
    ConfiguratorProductOptions,
    ConfiguratorProductTypes,
    ProductFamilyIconsInner,
    Product
} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, Language, URI_DOWNLOADOFFER} from "App/constants";
import {Basket} from "App/basket";
import {List} from "immutable";
import {UserState} from "App/user";
import {Ribbon} from "App/fragments/Ribbon";
import {Spinner} from "App/fragments/Spinner";
import {ContactInfo} from "Components/ContactInfo";
import {selectedLang} from "App/helper";

interface StateToProps extends CurrencyProps {
    subcategory: ProductFamilyIconsInner
    product: Product
    configuration: ConfiguratorProduct;
    basket: Basket;
    user: UserState|null;
}

interface DispatchToProps {
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
});

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {
    render() {
        const {subcategory, product, configuration, i18n, currency, basket, t, user} = this.props;
        const chosenType: ConfiguratorProductTypes | undefined = configuration.types.find((type:ConfiguratorProductTypes) => type.typeid===basket.machineid);
        const language: Language = selectedLang(i18n);
        return <Card className="pt-2">
            {basket.specialdiscount?<Ribbon className={"ribbon-normal-" + language}/>:null}
            <CardBody className="bodyslice pb-1">
                <div className="title-small-uppercase">{subcategory.nameml[language]}</div>
                <div className="title-large-uppercase">{chosenType?chosenType.name:configuration.nameml[language]}</div>
                <CardImg src={product.iconurl} alt={configuration.nameml[language]} className="p-0 card-image-small mx-auto d-block"/>
            </CardBody>
            <CardBody className="bodyslice pb-3">
                {product.maincharacteristic1nameml ?
                    <Row className="pt-2 no-gutters">
                        <Col className="col-md-5 text-small-resume">{product.maincharacteristic1value}</Col>
                        <Col className="col-md-7 title-small-uppercase pr-2">{product.maincharacteristic1nameml[language]}</Col>
                    </Row>:
                    null
                }
                {product.maincharacteristic2nameml ?
                    <Row className="pt-2 no-gutters">
                        <Col className="col-md-5 text-small-resume">{product.maincharacteristic2value}</Col>
                        <Col className="col-md-7 title-small-uppercase pr-2">{product.maincharacteristic2nameml[language]}</Col>
                    </Row>:
                    null
                }
                {product.maincharacteristic3nameml ?
                    <Row className="pt-2 no-gutters">
                        <Col className="col-md-5 text-small-resume">{product.maincharacteristic3value}</Col>
                        <Col className="col-md-7 title-small-uppercase pr-2">{product.maincharacteristic3nameml[language]}</Col>
                    </Row>:
                    null
                }
                {
                    // Add selected options
                    basket.options.size?
                        <Row className="pt-2 no-gutters">
                            <div className="title-small-uppercase w-100">{t('products.configuration.extras')}</div>
                            <ul className="u-list">
                            {
                                basket.options.map((list: List<number>, key: number) => {
                                    var category: ConfiguratorProductCategories | undefined = configuration.categories.find((item: ConfiguratorProductCategories) => item.categoryid === Number(key));
                                    return list.map((id: number) => {
                                        const option: ConfiguratorProductOptions | undefined = category ? category.options.find((option: ConfiguratorProductOptions) => option.optionid === id) : undefined;
                                        return option ? <li key={key + '-' + id} className="text-list-resume">{option.titleml[language]}</li>:null;
                                    })
                                }).valueSeq()
                            }
                            </ul>
                        </Row>:
                        null
                }
                {
                    // Add selected quick couplers
                    basket.quickCouplerBuckets.length?
                        <Row className="pt-2 no-gutters">
                            <div className="title-small-uppercase w-100">{t('products.configuration.quickcoupler')}</div>
                            <ul className="u-list">
                                {
                                    basket.quickCouplerBuckets.map((quick: ConfiguratorProductBuckets, index: number) => {
                                        return <li key={quick.bucketid} className="text-list-resume">{quick.titleml[language]}</li>;
                                    })
                                }
                            </ul>
                        </Row>:
                        null
                }
            </CardBody>
            <CardBody className="bodyslice">
                <Row className="no-gutters pb-3">
                    <Col className="col-md-6 align-self-center">
                        <div className="text-normal-overview">{ t('products.configuration.pricelabel') }</div>
                    </Col>
                    <Col className="col-md-6 d-flex justify-content-end">
                        <Spinner active={basket.syncState.pending}/>
                        <div className={"pl-1 d-inline text-bold-uppercase-overview text-right " + (basket.syncState.pending?"updating":"")}>{ t('products.configuration.price', {amount:(basket.totalprice?basket.totalprice:'-'), unit:currency}) }</div>
                    </Col>
                </Row>
            </CardBody>
            {user&&basket.purchaseid ?
                <CardBody className="bodyslice py-3">
                    <Row className="no-gutters mt-1">
                        <Col className="action col-md-12 d-flex flex-column text-center" onClick={() => window.open(URI_DOWNLOADOFFER + basket.purchaseid, '_blank')}>
                            <i className="far fa-file-pdf fa-lg"></i>
                            <span
                                className="pt-2 text-action-document text-center">{t('products.configuration.pdf')}</span>
                        </Col>
                    </Row>
                </CardBody> :
                null
            }
            <ContactInfo basket={basket} user={user} configuration={configuration} />
        </Card>
    }
}

export const ContactOverviewPage = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/ContactOverview.tsx